import React from 'react';
import { stage } from '../../common/config';

class WhiteHeader extends React.Component {
  componentDidMount(): void {
    const scriptHeader = document.createElement('script');
    scriptHeader.async = true;
    scriptHeader.src = `https://content.header.immobilienscout24.de/main/${stage()}/is24-de-header-light.js`;
    document.head.appendChild(scriptHeader);
  }

  render(): JSX.Element {
    return (
      <div className='margin-bottom'>
        <div id='white-header' className={'inject is24-de-header-light'} />
      </div>
    );
  }
}

export default WhiteHeader;
